// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1M4MZ","buttons":"SendReceipts_buttons__3J2ss","email":"SendReceipts_email__J_s-j","bookApptTitle":"SendReceipts_bookApptTitle___pe1U"};